import React from "react";
import logo from "../assets/baja-logo-light.png";

// Official Baja Designs logo lockup (provided brand asset).
export default function BrandLogo({ size = 44, className = "" }) {
  return (
    <img
      src={logo}
      alt="Baja Designs — The Scientists of Lighting"
      style={{ height: size }}
      className={`w-auto object-contain ${className}`}
    />
  );
}
